/* BeautyJunkies — поведение страницы лояльности.
   Подключается из templates/page.joy-loyalty.json, секция bj_brand_style.

   1. Шаги «Как это работает»: ссылки Joy открываются в новой вкладке и не
      понимают якоря, поэтому поведение переопределено. Первый и третий шаги
      не кликаются (это сделано в css), второй прокручивает к «Как копятся Beauties».
   2. Кнопка реферального блока (#joy-open) открывает окно Joy через
      avadaJoyTrigger() — прямое открытие вкладки рефералки закрыто тарифом.
   3. Гостям перед кнопкой «Войти» показывается подсказка «Войдите, чтобы
      увидеть ваш баланс» на языке страницы. Вошедшим не показывается: им баннер
      и так пишет имя и баланс. Баннер Joy дорисовывает после загрузки страницы,
      поэтому подсказка ждёт его появления и переживает перерисовки. */
(function () {
  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || !event.target.closest) return;

      var joyLink = event.target.closest('a[href="#joy-open"]');
      if (joyLink) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof window.avadaJoyTrigger === 'function') window.avadaJoyTrigger();
        return;
      }

      var item = event.target.closest('.Joy-Work__Item');
      if (!item || !item.parentElement) return;

      var index = Array.prototype.indexOf.call(item.parentElement.children, item);

      if (index === 1) {
        event.preventDefault();
        event.stopPropagation();
        var target = document.getElementById('beauties');
        if (target) target.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    },
    true
  );

  var HINTS = {
    sr: 'Prijavi se da vidiš koliko Beauties imaš.',
    ru: 'Войдите, чтобы увидеть ваш баланс.',
    en: 'Sign in to see your balance.'
  };

  function tryInsertHint() {
    if (document.querySelector('.bj-signin-hint')) return true;
    var group = document.querySelector('.Joy-Hero-Banner_ActionGroup');
    if (!group) return false;
    var joy = window.AVADA_JOY || {};
    if (joy.customer && joy.customer.id) return true;
    var locale = (window.Shopify && window.Shopify.locale) || 'sr';
    var hint = document.createElement('p');
    hint.className = 'bj-signin-hint';
    hint.textContent = HINTS[locale] || HINTS.sr;
    group.parentElement.insertBefore(hint, group);
    return true;
  }

  function watchHint() {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      tryInsertHint();
      if (tries >= 40) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchHint);
  } else {
    watchHint();
  }
})();